export interface EventData {
  eventType: string;
  eventId: string;
}

export enum StepEnum {
  DATA = 'DATA',
  PHOTO = 'PHOTO',
  CONFIRM = 'CONFIRM',
  OFFICIAL = 'OFFICIAL',
  QRCODE = 'QRCODE',
  RFID = 'RFID',
  PRIVACY = 'PRIVACY',
  WITNESS = 'WITNESS',
  DOCUMENT = 'DOCUMENT',
  REFERENCE_VDTS = 'REFERENCE_VDTS',
  VDT_MINTED = 'VDT_MINTED',
}

export type EventRelationType = 'CHECKIN_OFFICIAL' | 'CHECKIN_WITNESS';
